exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!ag-grid-community/dist/styles/ag-grid.css"), "");
exports.i(require("-!../../../../node_modules/css-loader/index.js!ag-grid-community/dist/styles/ag-theme-balham.css"), "");

// module
exports.push([module.id, ".catalog-loader[data-v-293a0688] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-direction: column;\n}", ""]);

// exports
